import React from 'react';
import { Card, CardContent, Typography, CardActions, Button, Grid, CardMedia } from '@mui/material';
import { Info } from '@mui/icons-material';
import UserImage from '../../images/User.png';
import BackOfficeImage from '../../images/back-office-image.png';
import FieldAgent from '../../images/field-agent.jpg'
import Staff from '../../images/staff.png';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  const cards = [
    {
      id: 1,
      title: 'Admin',
     // description: 'Description for Card 1',
      color: '#FFB3AB',
      image: UserImage, // Placeholder image
      route: '/UserList'
    },
    {
      id: 2,
      title: 'Back Office',
      //description: 'Description for Card 2',
      color: '#FFDAB9',
      image: BackOfficeImage, // Placeholder image
       route: '/ProductList'
    },
    {
      id: 3,
      title: 'Field Agent',
      //description: 'Description for Card 3',
      color: '#BFD8B8',
      image: FieldAgent,
       route: '/Locations'
    },
    {
      id: 4,
      title: 'Staff',
      //description: 'Description for Card 4',
      color: '#D3CCE3',
      image: Staff,
       route: '/RouteList'
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Welcome to the Landing Page
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {cards.map((card) => (
          <Grid item key={card.id} xs={12} sm={6} md={3}>
            <Link to={card.route} style={{ textDecoration: 'none' }}>
            <Card
              sx={{
                height: '300px',
                backgroundColor: card.color,
                boxShadow: 3,
                borderRadius: 3,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: 6,
                },
              }}
            >
              {/* Add image to the top half of the card */}
              <CardMedia
                component="img"
                height="250"
                image={card.image}
                alt={card.title}
                sx={{
                  objectFit: 'cover', // Ensures image covers the area without stretching
                  borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px',
                }}
              />
              <CardContent>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'white' }}>
                  {card.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'white' }}>
                  {card.description}
                </Typography>
              </CardContent>
             
            </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default LandingPage;